// One AI job produces both the transcript and the summary; longer audio is refused by the provider.
export const TRANSCRIBE_MAX_DURATION = 30 * 60;
